import {
  AddKegiatanSosialPayload,
  EditKegiatanSosialPayload,
} from "../../../../models/KegiatanSosial";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { allKegiatanSosialKey } from "../../queries/KegiatanSosial/useFetchAllKegiatanSosial";
import getQueryClient from "../../queryClient";

export async function editKegiatanSosial(data: EditKegiatanSosialPayload) {
  const res = await ApiClient.put(`/EditKegiatanSosial`, data);
  return res.data;
}

export const useEditKegiatanSosial = mutationWrapper(editKegiatanSosial, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allKegiatanSosialKey);
  },
});
